__turbopack_context__.v({
  "actionsNav": "BoatGallery-module-scss-module__yj0Dfa__actionsNav",
  "coverWrapper": "BoatGallery-module-scss-module__yj0Dfa__coverWrapper",
  "galleryImage": "BoatGallery-module-scss-module__yj0Dfa__galleryImage",
  "galleryWrapper": "BoatGallery-module-scss-module__yj0Dfa__galleryWrapper",
  "itemNavArrow": "BoatGallery-module-scss-module__yj0Dfa__itemNavArrow",
  "itemNavArrowIcon": "BoatGallery-module-scss-module__yj0Dfa__itemNavArrowIcon",
  "noCoverWrapper": "BoatGallery-module-scss-module__yj0Dfa__noCoverWrapper",
});
